<script lang="ts">
	import type { PortableTextBlock } from "@portabletext/types";
	import { contentBlockComponents } from "./utils";
	import { PortableText } from "@portabletext/svelte";

	interface Props {
		class?: string;
		content: PortableTextBlock[];
	}

	let { class: classes = "", content }: Props = $props();
</script>

<div class={classes}>
	<span class="pre-content siblings-prose siblings-leading-normal"></span>

	{#if content?.length}
		<PortableText value={content} components={contentBlockComponents} onMissingComponent={false} />
	{/if}
</div>

<style lang="postcss">
	.pre-content ~ :global(*) {
		line-height: var(--line-height, inherit);
		width: min(100%, var(--content-width, var(--w-prose-edge-x)));
		padding-inline: var(--content-px, var(--space-edge-x));
	}

	/* lists */
	.pre-content ~ :global(* li) {
		margin-block: var(--s-1);
	}

	.pre-content ~ :global(:where(ol, ul) :where(ol, ul)) {
		margin-block: 0;
	}

	.pre-content ~ :global(ol) {
		list-style: inside decimal;
	}

	.pre-content ~ :global(ul) {
		list-style: inside disc;
	}

	.pre-content ~ :global(:where(ol, ul) ol) {
		padding-inline-start: var(--space-inline);
		list-style: decimal;
	}

	.pre-content ~ :global(:where(ol, ul) ul) {
		padding-inline-start: var(--space-inline);
		list-style: disc;
	}

	@media (min-width: 1200px) {
		.pre-content ~ :global(ol) {
			list-style: decimal;
		}
		.pre-content ~ :global(ul) {
			list-style: disc;
		}
	}
</style>
